import React, { Component } from "react";
import Scrollbars from "react-custom-scrollbars-2";

import styles from "./ownershipAreasRadioBottoms.module.scss";

class OwnershipAreasRadioBottoms extends Component {

  render() {
    const { ownershipAreas, onHandleClick, selectId, isSerchFilter } = this.props;

    return ownershipAreas ? (
      <Scrollbars ref="scrollbar" style={{ height: "45px" }} autoHide={false} autoHeightMax={50} renderTrackVertical={() => <div></div>}>
        <div className={styles.ownershipAreasContainer}>
          {ownershipAreas.map((item) => {
            if (isSerchFilter && item.count === 0) {
              return null;
            }

            return (
              <div
                key={item.id}
                className={item.id == selectId ? styles.ownershipAreaItemActive : styles.ownershipAreaItem}
                onClick={() => {
                  onHandleClick(item.id);
                }}
              >
                {item.title} {item.count}
              </div>
            );
          })}
        </div>
      </Scrollbars>
    ) : null;
  }
}

export default React.memo(OwnershipAreasRadioBottoms);
